import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=c2cc2f52&scoped=true"
import script from "./NavList.vue?vue&type=script&lang=js"
export * from "./NavList.vue?vue&type=script&lang=js"
import style0 from "./NavList.vue?vue&type=style&index=0&id=c2cc2f52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cc2f52",
  null
  
)

export default component.exports